export default {
  // General UI elements
  save: "Guardar",
  saving: "Guardando",
  cancel: "Cancelar",
  edit: "editar",
  delete: "Eliminar",
  profile: "Perfil",
  settings: "Configuración",
  logout: "Cerrar Sesión",
  language: "Idioma",
  loading: "Cargando",
  submit: "Enviar",
  search: "Buscar...",
  back: "Atrás",
  next: "Siguiente",
  previous: "Anterior",
  continue: "Continuar",
  done: "Hecho",
  error: "Error",
  success: "Éxito",
  warning: "Advertencia",
  info: "Información",
  close: "Cerrar",
  open: "Abrir",
  yes: "Sí",
  no: "No",
  ok: "OK",
  
  // Authentication
  auth: {
    signIn: "Iniciar sesión",
    signUp: "Registrarse",
    signOut: "Cerrar sesión",
    forgotPassword: "¿Olvidaste tu contraseña?",
    resetPassword: "Restablecer contraseña",
    sendResetLink: "Enviar enlace de restablecimiento",
    createAccount: "Crear cuenta",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    dontHaveAccount: "¿No tienes una cuenta?",
    or: "O",
    continueWith: "Continuar con",
    google: "Google",
    facebook: "Facebook",
    apple: "Apple",
    twitter: "Twitter",
    passwordRequirements: "La contraseña debe tener al menos 8 caracteres",
    passwordMatch: "Las contraseñas deben coincidir",
    emailInvalid: "Por favor, introduce una dirección de correo electrónico válida"
  },
  
  // Profile specific
  username: "Nombre de usuario",
  email: "Correo electrónico",
  password: "Contraseña",
  confirmPassword: "Confirmar contraseña",
  joinDate: "Fecha de registro",
  streak: "Racha",
  xp: "XP",
  plan: "Plan",
  free: "Gratis",
  pro: "Pro",
  premium: "Premium",
  referralCode: "Código de referencia",
  share: "Compartir",
  copy: "Copiar",
  copied: "¡Copiado!",
  contactUs: "Contáctenos",
  termsOfService: "Términos de servicio",
  privacyPolicy: "Política de privacidad",
  accountSettings: "Configuración de la cuenta",
  changePassword: "Cambiar contraseña",
  deleteAccount: "Eliminar cuenta",
  deleteAccountConfirm: "¿Estás seguro de que quieres eliminar tu cuenta? Esta acción no se puede deshacer.",
  updateProfile: "Actualizar perfil",
  profileUpdated: "Perfil actualizado con éxito",
  memberSince: "Miembro desde",
  noSetsYet: "Aún no hay conjuntos :(", 
  upgradeToPro: "¡Actualízate a Pro!",
  recentActivity: "Actividad Reciente",
  settings: "Configuración",
  shareWithAFriend: "Compartir con un Amigo",
  contactTheTeam: "Contacta con el Equipo",
  termsAndConditions: "Términos y Condiciones",
  editUsername: "Editar nombre de usuario:",
  logOut: "Cerrar sesión",
  usernameError1: "El nombre de usuario no puede estar vacío",
  usernameError2: "Por favor, introduce un nombre de usuario diferente o nuevo",
  usernameError3: "El nombre de usuario no puede contener espacios",
  usernameError4: "El nombre de usuario no puede contener letras mayúsculas",
  usernameError5: "El nombre de usuario no puede contener caracteres especiales",
  usernameError6: "El nombre de usuario debe tener entre 4 y 18 caracteres",
  usernameError7: "El nombre de usuario contiene contenido inapropiado",
  usernameError8: "Este nombre de usuario ya está en uso",
  clickOrDragAndDrop: "Haz clic o arrastra y suelta para subir", 
  confirm: "Confirmar",
  retake: "Volver a tomar",

  // BottomNav
  profile: "Perfil",
  home: "Inicio",
  library: "Mi Biblioteca",
  saved: "Guardado",
  rankings: "Clasificaciones",

  // Feature
  backToLibrary: "Volver a la Biblioteca",
  exploreSets: "Explorar Conjuntos",
  communitySets: "Conjuntos de la Comunidad",
  mySets: "Mis Conjuntos",
  alreadyAdded: "Ya añadido",
  addToLibrary: "Añadir a la Biblioteca",
  loading: "Cargando...",
  loadMoreSets: "Cargar más conjuntos",
  by: "Por",
  makePublic: "Hacer público",
  subscriptionRequired: "Suscripción Requerida",
  subscriptionRequiredMessage: "Solo puedes tener 10 conjuntos a la vez en la biblioteca. ¡Actualiza a premium para conjuntos ilimitados!",

  // My Library
  deleteSet: "Eliminar Conjunto",
  deleteSetConfirmation: "¿Estás seguro de que quieres eliminar este conjunto?",
  yesDelete: "Sí, Eliminar",
  collections: "Conjuntos Públicos",
  myLibrary: "Mi Biblioteca",
  outOf10Sets: "de 10 conjuntos añadidos.",
  switchBackToPro: "Cambiar a Pro",
  upgradeToPro: "Mejorar a Pro",
  outOf10OnFree: "de 10 en gratuito.",
  letMeCook: "Déjame cocinar",
  selectMode: "Seleccionar Modo",
  multipleChoice: "Opción Múltiple",
  flashcards: "Tarjetas Flash",
  freeResponse: "Respuesta Libre",
  proOnly: "Sólo para Pro",
  leaderboard: "Tabla de Clasificación",
  favorites: "Favoritos",
  profile: "Perfil",
  reportBugs: "Reportar Errores",

  // Question Card
  correctMessage: "¡Correcto! ¡Has Cocinado!",
  typeYourAnswer: "Escribe tu respuesta aquí...",
  submitAnswer: "Enviar Respuesta",
  responseCannotBeBlank: "La respuesta no puede estar vacía",
  noAnswerAvailable: "No hay respuesta disponible",
  answerGuideline: "Directrices de Respuesta",
  pleaseSubmitAnswerFirst: "Por favor, envía tu respuesta primero",
  revealAnswer: "Revelar Respuesta",
  hideAnswer: "Ocultar Respuesta",
  gradingInProgress: "Calificando...",
  grading: "Calificación",
  answerGuidelines: "Directrices de Respuesta",
  finalScore: "Puntuación Final:",
  evaluateAnswer: "Evaluar Respuesta",

  // Saved
  favorites: "Favoritos",
  searchQuestions: "Buscar preguntas...",
  noSavedQuestions: "No hay preguntas guardadas aún.",

  // Scroller
  loadingMoreQuestions: "Cargando Más Preguntas",

  // New Prompt
  deleteSet: "Eliminar Conjunto",
  deleteSetConfirmation: "¿Estás seguro de que quieres eliminar este conjunto?",
  yesDelete: "Sí, Eliminar",
  cancel: "Cancelar",
  setLimitReached: "Límite de Conjuntos Alcanzado",
  setLimitError: "Solo puedes tener 10 conjuntos a la vez en la biblioteca. ¡Actualiza a Premium para conjuntos ilimitados!",
  close: "Cerrar",
  uploadNotes: "Subir Notas",
  general: "General",
  title: "Título",
  setTitleMessage: "Establece un título para tus preguntas generadas por AI de Cookr, para que sea fácil de acceder más tarde.",
  titleError1: "El título no puede estar en blanco",
  titleError2: "El título contiene contenido inapropiado",
  content: "Contenido",
  setContentMessage: "Copia y pega tus notas, clases o cualquier otro contenido textual.",
  contentError1: "El contenido no puede estar en blanco",
  contentError2: "El contenido contiene contenido inapropiado",
  subject: "Asunto",
  setSubjectMessage: "¿De qué asunto o tema se trata este contenido?",
  subjectError1: "El asunto no puede estar en blanco",
  subjectError2: "El asunto contiene contenido inapropiado",

  // Payment Confirmation
  returnToProfile: "Volver al Perfil",

  // Plans
  confirmSwitch: "Confirmar Cambio al Plan Gratis",
  confirmSwitchMessage: "¿Estás seguro de que quieres cambiar al Plan Gratis? Perderás acceso a las funciones premium.",
  buttonConfirm: "Confirmar Cambio",
  processing: "Procesando...",
  unlimitedScrolling: "Desplazamiento Ilimitado",
  unlimitedSubjects: "Asuntos Ilimitados",
  aiTutorBot: "Bot de Tutor AI",
  newFeatureAccess: "Acceso a Nuevas Características",
  saveScrolls: "Guardar Scrolls",
  infiniteNoteUploads: "Cargas de Notas Ilimitadas",
  answerExplanations: "Explicaciones de las Respuestas",
  shareScrolls: "Compartir Scrolls",
  everythingInStandard: "Todo en Estándar",
  current: "Actual",
  switchOver: "Cambiar a",
  forever: "/para siempre",
  monthly: "/mes",
  yearly: "/año",

  // Leaderboard
  leaderboard: "Clasificación",

  // Home.js
  pickASubject: "Elige un asunto para comenzar tu sesión!",

  // scrollerLoader
  generatingContent: "Generando Contenido...",

  // Dropdown
  choose: "Elige",
  titleTooLong: "El título no puede tener más de 100 caracteres",

}
